import React, { useState } from 'react';
import { Camera } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EnhancedCamera } from './EnhancedCamera';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';

interface CameraButtonProps {
  onPhotoCapture: (file: File) => Promise<void>;
  disabled?: boolean;
}

export const CameraButton: React.FC<CameraButtonProps> = ({
  onPhotoCapture,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePhotoCapture = async (file: File) => {
    await onPhotoCapture(file);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          size="sm"
          disabled={disabled}
          className="bg-orange-500 hover:bg-orange-600 text-white border-0 text-xs"
        >
          <Camera className="h-4 w-4 mr-1" />
          Take Photo
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <EnhancedCamera onPhotoCapture={handlePhotoCapture} disabled={disabled} />
      </DialogContent>
    </Dialog>
  );
};